import PropTypes from 'prop-types';
import React from 'react';
import onlyASCII from '@htmniseko/htm-validators/utils/ASCII/onlyASCII';
import TextField from './TextField';

const EmailField = ({ id, disabled, doubleAsterisk, hideLabel, hideRequiredAsterisk, hideTooltip, label, readOnly, required, validation, fieldSizeSM }) => (
  <TextField
    disabled={disabled}
    doubleAsterisk={doubleAsterisk}
    fullWidth
    id={id}
    hideLabel={hideLabel}
    hideRequiredAsterisk={hideRequiredAsterisk}
    hideTooltip={hideTooltip}
    label={label}
    name={id}
    normalize={onlyASCII}
    readOnly={readOnly}
    required={required}
    type="email"
    validation={validation}
    childrenSizeSM={fieldSizeSM}
  />
);

EmailField.propTypes = {
  id: PropTypes.string,
  disabled: PropTypes.bool,
  doubleAsterisk: PropTypes.bool,
  hideLabel: PropTypes.bool,
  hideRequiredAsterisk: PropTypes.bool,
  hideTooltip: PropTypes.bool,
  label: PropTypes.string,
  readOnly: PropTypes.bool,
  required: PropTypes.bool,
  validation: PropTypes.func,
  fieldSizeSM: PropTypes.number,
};

EmailField.defaultProps = {
  disabled: false,
  doubleAsterisk: false,
  hideLabel: false,
  hideRequiredAsterisk: false,
  hideTooltip: false,
  readOnly: false,
  required: false,
  fieldSizeSM: 9,
};

export default EmailField;
